var _LinkedListEnumerator_linkedList, _LinkedListEnumerator_currentIndex;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class LinkedListEnumerator extends EnumeratorBase {
    constructor(linkedList) {
        super();
        _LinkedListEnumerator_linkedList.set(this, void 0);
        _LinkedListEnumerator_currentIndex.set(this, void 0);
        __classPrivateFieldSet(this, _LinkedListEnumerator_linkedList, linkedList, "f");
        __classPrivateFieldSet(this, _LinkedListEnumerator_currentIndex, -1, "f");
    }
    get current() {
        return __classPrivateFieldGet(this, _LinkedListEnumerator_linkedList, "f").item(__classPrivateFieldGet(this, _LinkedListEnumerator_currentIndex, "f"));
    }
    moveNext() {
        var _a;
        try {
            const item = this.peek();
            if (item === undefined) {
                return false;
            }
            __classPrivateFieldSet(this, _LinkedListEnumerator_currentIndex, (_a = __classPrivateFieldGet(this, _LinkedListEnumerator_currentIndex, "f"), _a++, _a), "f");
            return true;
        }
        catch {
            return false;
        }
    }
    peek() {
        const item = __classPrivateFieldGet(this, _LinkedListEnumerator_linkedList, "f").item(__classPrivateFieldGet(this, _LinkedListEnumerator_currentIndex, "f") + 1);
        if (item === undefined) {
            throw new Exception("End of enumerator");
        }
        return item;
    }
    reset() {
        __classPrivateFieldSet(this, _LinkedListEnumerator_currentIndex, -1, "f");
    }
}
_LinkedListEnumerator_linkedList = new WeakMap(), _LinkedListEnumerator_currentIndex = new WeakMap();
